import i18n from '@/i18n/i18n'

export const SETTINGS_USERS_ROUTE = 'users'
export const SETTINGS_USERS_INVITATIONS_ROUTE = 'users.invitations'
export const SETTINGS_USERS_LINKED_USERS_ROUTE = 'users.linked'

export default {
  name: SETTINGS_USERS_ROUTE,
  path: 'users',
  redirect: { name: SETTINGS_USERS_INVITATIONS_ROUTE },
  component: () => import('@/app/settings/users/views/UsersNav.vue'),
  children: [
    {
      name: SETTINGS_USERS_INVITATIONS_ROUTE,
      path: 'users/invitations',
      component: () => import('@/app/settings/users/views/InvitedUsers.vue'),
      meta: {
        pageTitle: () => i18n.t('Users'),
        permissions: ['manage_subusers'],
      },
    },
    {
      name: SETTINGS_USERS_LINKED_USERS_ROUTE,
      path: 'users/manage',
      component: () => import('@/app/settings/users/views/ActiveUsers.vue'),
      meta: {
        pageTitle: () => i18n.t('Users'),
        permissions: ['manage_subusers'],
      },
    },
  ],
}
